import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { VActionIcon } from '@vision/ui/components/VActionIcon/VActionIcon';
import { forwardRef } from 'react';
import type { RowActionButtonOptions } from './types';

export const AddRowButton = forwardRef<HTMLButtonElement, RowActionButtonOptions>(({ label, ...props }, ref) => (
  <VActionIcon
    color="blue.5"
    size="input-sm"
    variant="filled"
    {...props}
    aria-label={label}
    ref={ref}
    tooltipLabel={label}
    type="button"
  >
    <FontAwesomeIcon icon={faCirclePlus} aria-hidden="true" />
  </VActionIcon>
));
